export default "__VITE_ASSET__8957face__"